<template>
    <div id="show-table-maintenance" class="show-table-maintenance" v-if="dataTableservices!=null">
        <!-- <div class="container"> -->
        <div class="row justify-content-center show-table-maintenance-content">
            <div class="col-12 col-md-12">
                <div class="container">
                    <h1 class="subscribe-title">รายการบำรุงรักษา<span class="t-inline">ทุกระยะทาง</span></h1>
                    <p class="text-subtitle">
                        รายการอะไหล่ที่ต้องเปลี่ยน <span class="t-inline">พร้อมค่าบริการ</span><span
                            class="t-inline"><span class="t-inline">ตามระยะทาง</span><span class="t-inline">ตั้งแต่
                                10,000</span> <span class="t-inline">จนถึง 200,000 กิโลเมตร</span></span>
                    </p>
                </div>

                <div id="collapse-show-result-periodical">
                    <!-- visible -->
                    <div id="show-periodical-table-block" class="show-periodical-table-block">

                        <!-- show-periodical-table pc -->
                        <div class="show-wrapper show-periodical-table-desktop">
                            <div class="show-periodical-table">
                                <table class="table-first">
                                    <tr class="row-head">
                                        <td class="col-name">
                                            รายการอะไหล่ <br /> &nbsp;
                                        </td>
                                        <td>
                                            จำนวนที่ใช้ <br /> &nbsp;
                                        </td>
                                        <td>
                                            ราคา/หน่วย <br />
                                            (บาท)
                                        </td>
                                        <td>
                                            ระยะเปลี่ยน <br />
                                            (กิโลเมตร)
                                        </td>
                                    </tr>

                                    <tr v-for="(dataTableserver , index) in dataTableservices.dataall_show"
                                        :key="index">
                                        <td class="col-name" :style="{ height:setHeightLoop(index)+'px' }">
                                            <div :ref="`listCell${index}`">
                                                {{ $parent.chkText(dataTableserver.partslist) }}
                                            </div>
                                        </td>
                                        <td>
                                            <!-- <pre>{{ dataTableserver.amountused }}</pre> -->
                                            <span v-html="$parent.chkBR($parent.chkText(dataTableserver.amountused))"></span>
                                        </td>
                                        <td>
                                            <!-- {{ $parent.chkText(dataTableserver.price_unit) }} -->
                                            <span v-html="$parent.chkBR($parent.chkText(dataTableserver.price_unit))"></span>
                                        </td>
                                        <td>
                                            <!-- {{ $parent.chkText(dataTableserver.mileagechange) }} -->
                                            <span v-html="$parent.chkBR($parent.chkText(dataTableserver.mileagechange))"></span>
                                        </td>
                                    </tr>

                                    <tr class="row-sum">
                                        <td colspan="4" class="col-name">
                                            ราคาอะไหล่ทั้งหมด
                                        </td>
                                    </tr>
                                    <tr class="row-sum">
                                        <td colspan="4" class="col-name">
                                            อัตราค่าแรง
                                        </td>
                                    </tr>
                                    <tr class="row-sum">
                                        <td colspan="4" class="col-name">
                                            รวมค่าอะไหล่ และค่าแรง
                                        </td>
                                    </tr>
                                    <tr class="row-total">
                                        <td colspan="4" class="col-name">
                                            รวมค่าใช้จ่ายในการบำรุงรักษาในระยะเวลา 5 ปี <br /><span
                                                class="t-inline">หรือ 100,000 กิโลเมตร*</span>
                                        </td>
                                    </tr>
                                    <tr class="row-total">
                                        <td colspan="4" class="col-name">
                                            รวมค่าใช้จ่ายในการบำรุงรักษาในระยะเวลา 6 - 10 ปี <br /><span
                                                class="t-inline">หรือ 200,000 กิโลเมตร*</span>
                                        </td>
                                    </tr>
                                </table>

                                <div class="distance-wrapper">
                                    <div class="frame">
                                        <div class="btn-slide">
                                            <div class="btn-prev arrow active animate-right-to-left hide"
                                                @click="slidePrev">
                                                <!-- <img :src="asset('images/chevron-left-black.svg')" alt="" /> -->
                                                <img :src="asset('images/service-arrow-left-black.png')" alt="" />
                                            </div>
                                            <div class="btn-next arrow active animate-left-to-right" @click="slideNext">
                                                <!-- <img :src="asset('images/chevron-right-black.svg')" alt="" /> -->
                                                <img :src="asset('images/service-arrow-right-black.png')" alt="" />
                                            </div>
                                        </div>
                                        <table class="distance-table">
                                            <tr class="row-head">
                                                <td colspan="10" class="d-none d-xl-table-cell">
                                                    ระยะทาง (กิโลเมตร) หรือ ระยะเวลา (เดือน)
                                                </td>
                                                <td colspan="10" class="d-none d-xl-table-cell">
                                                    ระยะทาง (กิโลเมตร) หรือ ระยะเวลา (เดือน)
                                                </td>
                                                <td colspan="20" class="d-table-cell d-xl-none">
                                                    ระยะทาง (กิโลเมตร) หรือ ระยะเวลา (เดือน)
                                                </td>
                                            </tr>

                                            <tr class="row-head-list">
                                                <!-- <td v-for="index in 20" :key="index" :class="{'hilist': ($parent.distanceSelect==(10000*index)) }"> -->
                                                <td v-for="index in 20" :key="index">
                                                    <!-- {{ $parent.chkText(10000*index) }} <span class="alt"
                                                        :class="{'d-inline-block d-xl-none': (index==10)}"
                                                        v-if="index!=20"></span> <br />/
                                                    {{ (6*index) }} -->
                                                    {{ $parent.chkText(10000*index) }} <br />/
                                                    {{ (6*index) }}
                                                </td>
                                            </tr>

                                            <!-- check text merge show -->
                                            <tbody
                                                v-for="(dataTableserver ,key, indexItem) in dataTableservices.dataall_show"
                                                :key="indexItem" class="text-merge-show">

                                                <tr :ref="`listCellSet${key}`"
                                                    :style="{height:setHeightLoop(key)+'px' }">
                                                    <template v-for="componentKey in 20">
                                                        <td :key="componentKey"
                                                            v-if="setkey2(componentKey,$parent.chkcolspan(dataTableserver['col'+(10000*componentKey)]))"
                                                            :colspan="$parent.chkcolspan(dataTableserver['col'+(10000*componentKey)])">
                                                            {{ $parent.chkText(dataTableserver['col'+(10000*componentKey)]) }}
                                                        </td>
                                                    </template>

                                                </tr>
                                            </tbody>
                                            <!-- check text merge show end -->
                                            <template
                                                v-for="(dataTableservice ,indexItem, count) in dataTableservices.totalall">
                                                <tr class="row-sum" v-if="count<3" :key="indexItem">
                                                    <td v-for="index in 20" :key="index">
                                                        {{ $parent.chkText(dataTableservice['col'+(10000*index)]) }}
                                                    </td>
                                                </tr>
                                            </template>

                                            <tr class="row-total">
                                                <td colspan="10" class="d-none d-xl-table-cell">
                                                    <!-- {{ $parent.chkText(dataTableservices.totalall_distance_first.col10000) }} -->
                                                    {{ $parent.chkTextSum(dataTableservices.dataall_total[0]['col10000']) }}
                                                    บาท
                                                </td>
                                                <td colspan="10" class="d-none d-xl-table-cell">
                                                    <!-- {{ $parent.chkText(dataTableservices.totalall_distance_first.col10000) }} -->
                                                    {{ $parent.chkTextSum(dataTableservices.dataall_total[0]['col10000']) }}
                                                    บาท
                                                </td>
                                                <td colspan="20" class="d-table-cell d-xl-none">
                                                    <!-- {{ $parent.chkText(dataTableservices.totalall_distance_first.col10000) }} -->
                                                    {{ $parent.chkTextSum(dataTableservices.dataall_total[0]['col10000']) }}
                                                    บาท
                                                </td>
                                            </tr>

                                            <tr class="row-total">
                                                <td colspan="10" class="d-none d-xl-table-cell">
                                                    <!-- {{ $parent.chkText(dataTableservices.totalall_sum.col10000) }} บาท -->
                                                    {{ $parent.chkTextSum(dataTableservices.dataall_total[1]['col10000']) }} บาท
                                                </td>
                                                <td colspan="10" class="d-none d-xl-table-cell">
                                                    <!-- {{ $parent.chkText(dataTableservices.totalall_sum.col10000) }} บาท -->
                                                    {{ $parent.chkTextSum(dataTableservices.dataall_total[1]['col10000']) }} บาท
                                                </td>
                                                <td colspan="20" class="d-table-cell d-xl-none">
                                                    <!-- {{ $parent.chkText(dataTableservices.totalall_sum.col10000) }} บาท -->
                                                    {{ $parent.chkTextSum(dataTableservices.dataall_total[1]['col10000']) }} บาท
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                <br class="clear-all" />
                            </div>
                        </div>
                        <!-- show-periodical-table pc end -->

                        <!-- show-periodical-table mobile -->
                        <div class="show-periodical-table-mobile">
                            <div class="service_periodical_fixed_scroll_mobile">
                                <div id="service-periodical-tbl-fixedscroll" class="service_periodical_fixed_scroll">
                                    <div class="table-wrap">

                                        <div id="icon-drag" class="click-and-drag-table"></div>
                                         <div class="box-show-icon"></div>
                                        <table class="main-table main-table-service-periodical">
                                            <thead>
                                                <tr class="service_periodical_tbl_row_head">
                                                    <th class="col_list_name fixed-side" scope="col" rowspan="2">
                                                        รายการอะไหล่ <br /> &nbsp;
                                                    </th>
                                                    <th class="col_list" scope="col" rowspan="2">
                                                        จำนวนที่ใช้ <br /> &nbsp;
                                                    </th>
                                                    <th class="col_list" scope="col" rowspan="2">
                                                        ราคา/หน่วย <br />
                                                        (บาท)
                                                    </th>
                                                    <th class="col_list" scope="col" rowspan="2">
                                                        ระยะเปลี่ยน <br />
                                                        (กิโลเมตร)
                                                    </th>
                                                    <!-- <th class="col_list_num" scope="col" colspan="20">
                                                            <div class="col-2">
                                                                ระยะทาง (กิโลเมตร) หรือ ระยะเวลา (เดือน)
                                                            </div>
                                                    </th> -->
                                                    <th v-for="index in 5" :key="index" class="col_num" scope="col" colspan="4">
                                                        ระยะทาง (กิโลเมตร) หรือ ระยะเวลา (เดือน)
                                                    </th>
                                                </tr>

                                                <tr class="service_periodical_tbl_row_head">
                                                    <th v-for="index in 20" :key="index" class="col_num" scope="col">
                                                        <span>{{ $parent.chkText(10000*index) }} กิโลเมตร </span><br>
                                                        <!-- <span class="alt"  v-if="index!=20">../..</span> -->
                                                        <span>/ {{ (6*index) }} เดือน</span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody
                                                v-for="(dataTableserver ,key, indexItem) in dataTableservices.dataall_show"
                                                :key="indexItem">
                                                <!-- <tr v-if="dataTableserver.text_merge!=null">
                                            <th class="col_list_name fixed-side">
                                              {{ $parent.chkText(dataTableserver.partslist) }}
                                            </th>
                                            <td class="col_list">
                                              {{ $parent.chkText(dataTableserver.amountused) }}
                                            </td>
                                            <td class="col_list">
                                              {{ $parent.chkText(dataTableserver.price_unit) }}
                                            </td>
                                            <td class="col_list">
                                              {{ $parent.chkText(dataTableserver.mileagechange) }}
                                            </td>
                                            <td colspan="20" class="col_num">
                                              {{ dataTableserver.text_merge }}
                                            </td>
                                        </tr> -->
                                                <tr>
                                                    <th class="col_list_name fixed-side">
                                                        {{ $parent.chkText(dataTableserver.partslist) }}
                                                    </th>
                                                    <td class="col_list">
                                                        <!-- {{ $parent.chkText(dataTableserver.amountused) }} -->
                                                        <span v-html="$parent.chkBR($parent.chkText(dataTableserver.amountused))"></span>
                                                    </td>
                                                    <td class="col_list">
                                                        <!-- {{ $parent.chkText(dataTableserver.price_unit) }} -->
                                                        <span v-html="$parent.chkBR($parent.chkText(dataTableserver.price_unit))"></span>
                                                    </td>
                                                    <td class="col_list">
                                                        <!-- {{ $parent.chkText(dataTableserver.mileagechange) }} -->
                                                        <span v-html="$parent.chkBR($parent.chkText(dataTableserver.mileagechange))"></span>
                                                    </td>

                                                    <template v-for="componentKey in 20">
                                                        <td :key="componentKey"
                                                            v-if="setkey3(componentKey,$parent.chkcolspan(dataTableserver['col'+(10000*componentKey)]))"
                                                            :colspan="$parent.chkcolspan(dataTableserver['col'+(10000*componentKey)])">
                                                            {{ $parent.chkText(dataTableserver['col'+(10000*componentKey)]) }}
                                                        </td>
                                                    </template>
                                                    <!-- <td v-for="index in 20" :key="index">
                                                {{ $parent.chkText(dataTableserver['col'+(10000*index)]) }}
                                            </td> -->
                                                </tr>
                                            </tbody>

                                            <tbody class="row-sum-total-box">
                                                <tr class="row-sum"
                                                    v-for="(dataTableservice ,indexItem, count) in dataTableservices.totalall"
                                                    :key="indexItem" v-if="count<3">
                                                    <th class="col_list_name fixed-side">
                                                        {{ textSum[count] }}
                                                    </th>
                                                    <td class="col_list" colspan="3">&nbsp;</td>
                                                    <td v-for="index in 20" :key="index" class="col_num">
                                                        {{ $parent.chkText(dataTableservice['col'+(10000*index)]) }}
                                                    </td>
                                                </tr>

                                                <tr class="row-total">
                                                    <th class="col_list_name fixed-side">
                                                        รวมค่าใช้จ่ายในการบำรุงรักษาในระยะเวลา 5 ปี <span
                                                            class="t-inline">หรือ 100,000 กิโลเมตร*</span>
                                                    </th>
                                                    <td class="col_list fixed-side" colspan="23">
                                                        <span class="col_list_num">
                                                            <!-- {{ $parent.chkText(dataTableservices.totalall_distance_first.col10000) }} -->
                                                             {{ $parent.chkTextSum(dataTableservices.dataall_total[0]['col10000']) }}
                                                            บาท
                                                        </span>
                                                    </td>
                                                </tr>

                                                <tr class="row-total">
                                                    <th class="col_list_name fixed-side">
                                                        รวมค่าใช้จ่ายในการบำรุงรักษาในระยะเวลา 6 - 10 ปี <span
                                                            class="t-inline">หรือ 200,000 กิโลเมตร*</span>
                                                    </th>
                                                    <td class="col_list fixed-side" colspan="23">
                                                        <span class="col_list_num">
                                                            <!-- {{ $parent.chkText(dataTableservices.totalall_sum.col10000) }} -->
                                                             {{ $parent.chkTextSum(dataTableservices.dataall_total[1]['col10000']) }}
                                                            บาท
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </div>

                                    <table class="main-table main-table-service-periodical clone">
                                        <thead>
                                            <tr class="service_periodical_tbl_row_head">
                                                <th class="col_list_name fixed-side" scope="col" rowspan="2">
                                                    รายการอะไหล่ <br /> &nbsp;
                                                </th>
                                                <th class="col_list" scope="col" rowspan="2">
                                                    จำนวนที่ใช้ <br /> &nbsp;
                                                </th>
                                                <th class="col_list" scope="col" rowspan="2">
                                                    ราคา/หน่วย <br />
                                                    (บาท)
                                                </th>
                                                <th class="col_list" scope="col" rowspan="2">
                                                    ระยะเปลี่ยน <br />
                                                    (กิโลเมตร)
                                                </th>
                                                <!-- <th class="col_list_num" scope="col" colspan="20">
                                                        <div class="col-2">
                                                            ระยะทาง (กิโลเมตร) หรือ ระยะเวลา (เดือน)
                                                        </div>
                                                </th> -->
                                                <th v-for="index in 5" :key="index" class="col_num" scope="col" colspan="4">
                                                    ระยะทาง (กิโลเมตร) หรือ ระยะเวลา (เดือน)
                                                </th>
                                            </tr>

                                            <tr class="service_periodical_tbl_row_head">
                                                <th v-for="index in 20" :key="index" class="col_num" scope="col">
                                                    <span>{{ $parent.chkText(10000*index) }} กิโลเมตร </span><br>
                                                    <!-- <span class="alt"  v-if="index!=20">../..</span> -->
                                                    <span>/ {{ (6*index) }} เดือน</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody
                                            v-for="(dataTableserver ,key, indexItem) in dataTableservices.dataall_show"
                                            :key="indexItem">
                                            <!-- <tr v-if="dataTableserver.text_merge!=null">
                                        <th class="col_list_name fixed-side">
                                            {{ $parent.chkText(dataTableserver.partslist) }}
                                        </th>
                                        <td class="col_list">
                                            {{ $parent.chkText(dataTableserver.amountused) }}
                                        </td>
                                        <td class="col_list">
                                            {{ $parent.chkText(dataTableserver.price_unit) }}
                                        </td>
                                        <td class="col_list">
                                            {{ $parent.chkText(dataTableserver.mileagechange) }}
                                        </td>
                                        <td colspan="20" class="col_num">
                                            {{ dataTableserver.text_merge }}
                                        </td>
                                    </tr> -->
                                            <tr>
                                                <th class="col_list_name fixed-side">
                                                    {{ $parent.chkText(dataTableserver.partslist) }} 
                                                </th>
                                                <td class="col_list">
                                                    <!-- {{ $parent.chkText(dataTableserver.amountused) }} -->
                                                    <span v-html="$parent.chkBR($parent.chkText(dataTableserver.amountused))"></span>
                                                </td>
                                                <td class="col_list">
                                                    <!-- {{ $parent.chkText(dataTableserver.price_unit) }} -->
                                                    <span v-html="$parent.chkBR($parent.chkText(dataTableserver.price_unit))"></span>
                                                </td>
                                                <td class="col_list">
                                                    <!-- {{ $parent.chkText(dataTableserver.mileagechange) }} -->
                                                    <span v-html="$parent.chkBR($parent.chkText(dataTableserver.mileagechange))"></span>
                                                </td>

                                                <template v-for="componentKey in 20">
                                                    <td :key="componentKey"
                                                        v-if="setkey3(componentKey,$parent.chkcolspan(dataTableserver['col'+(10000*componentKey)]))"
                                                        :colspan="$parent.chkcolspan(dataTableserver['col'+(10000*componentKey)])">
                                                        {{ $parent.chkText(dataTableserver['col'+(10000*componentKey)]) }}
                                                    </td>
                                                </template>
                                                <!-- <td v-for="index in 20" :key="index">
                                            {{ $parent.chkText(dataTableserver['col'+(10000*index)]) }}
                                        </td> -->
                                            </tr>
                                        </tbody>

                                        <tbody class="row-sum-total-box">
                                            <tr class="row-sum"
                                                v-for="(dataTableservice ,indexItem, count) in dataTableservices.totalall"
                                                :key="indexItem" v-if="count<3">
                                                <th class="col_list_name fixed-side">
                                                    {{ textSum[count] }}
                                                </th>
                                                <td class="col_list" colspan="3">&nbsp;</td>
                                                <td v-for="index in 20" :key="index" class="col_num">
                                                    {{ $parent.chkText(dataTableservice['col'+(10000*index)]) }}
                                                </td>
                                            </tr>

                                            <tr class="row-total">
                                                <th class="col_list_name fixed-side">
                                                    รวมค่าใช้จ่ายในการบำรุงรักษาในระยะเวลา 5 ปี <span
                                                        class="t-inline">หรือ 100,000 กิโลเมตร*</span>
                                                </th>
                                                <td class="col_list fixed-side" colspan="23">
                                                    <span class="col_list_num">
                                                        <!-- {{ $parent.chkText(dataTableservices.totalall_distance_first.col10000) }} -->
                                                            {{ $parent.chkTextSum(dataTableservices.dataall_total[0]['col10000']) }}
                                                        บาท
                                                    </span>
                                                </td>
                                            </tr>

                                            <tr class="row-total">
                                                <th class="col_list_name fixed-side">
                                                    รวมค่าใช้จ่ายในการบำรุงรักษาในระยะเวลา 6 - 10 ปี <span
                                                        class="t-inline">หรือ 200,000 กิโลเมตร*</span>
                                                </th>
                                                <td class="col_list fixed-side" colspan="23">
                                                    <span class="col_list_num">
                                                        <!-- {{ $parent.chkText(dataTableservices.totalall_sum.col10000) }} -->
                                                            {{ $parent.chkTextSum(dataTableservices.dataall_total[1]['col10000']) }}
                                                        บาท
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- show-periodical-table mobile end -->

                    </div>
                </div>

                <div class="container">
                    <!-- <div class="btn-more-less-area">
                        <b-button class="btn-more-less"
                            v-b-toggle="['collapse-show-result-periodical', 'collapse-show-result-periodical-btn']"
                            @click="scrollToShowTablePeriodical">
                            <span class="when-open"><span class="text">ซ่อน</span> <img class="icon-arrow"
                                    :src="asset('images/chevron-up-grey.svg')" alt="" /></span>
                            <span class="when-closed"><span class="text">รายละเอียดเพิ่มเติม</span> <img
                                    class="icon-arrow" :src="asset('images/chevron-down-grey.svg')" alt="" /></span>
                        </b-button>
                    </div> -->
                    <!-- btn-more-less -->

                    <b-collapse id="collapse-show-result-periodical-btn" class="collapse-show-result-periodical-btn"
                        @shown="setscroll" @hidden="setscroll" @show="setdataTable()">
                        <!-- visible -->
                        <div class="row justify-content-center">
                            <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
                                <a class="btn btn-primary btn-arrow btn-arrow-right setbt-w first gtm-service-table-btn-booking"
                                    href="https://servicebooking.honda.co.th/" target="_blank">
                                    <span>นัดหมายเข้ารับบริการ</span>
                                </a>
                            </div>

                            <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-start">
                                <a class="btn-download gtm-service-table-btn-download"
                                    :href="'/periodical-result-pdf/data?id='+$parent.idModel+'&idengine='+$parent.idEngine+'&idengine='+$parent.idEngine+'&model='+$parent.nameModel+'&year='+$parent.year+'&enginename='+$parent.nameEngine"
                                    target="_blank">
                                    <div class="btn btn-secondary btn-arrow btn-arrow-right setbt-w">
                                        <span>ดาวน์โหลด</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div>
        <!-- </div> -->
    </div>
</template>

<script>
    let setColspan;
    let checkM = true;
    let colspanM = 0;
    let loopM = 0;
    let checkM2 = true;
    let colspanM2 = 0;
    let loopM2 = 0;
    export default {
        data() {
            return {
                timechk: null,
                table_height: null,
                table_height2: null,
                table_height3: null,
                chkOpentableAll: false,
                textSum: ["ราคาอะไหล่ทั้งหมด", "อัตราค่าแรง", "รวมค่าอะไหล่ และค่าแรง"],
            }
        },
        mounted() {
            //    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
            //         if(collapseId=='collapse-show-result-periodical' && isJustShown==true){
            //             // this.setdataTable();
            // this.setHeight();
            //         }
            //     })

        },
        props: {
            dataTableservices: {
                type: Object,
                default: null
            }
        },
        methods: {
            setkey(currentLoop, colspan) {
                //check reset setCalspan
                if (currentLoop === 20 || setColspan >= 20 || (currentLoop == setColspan)) {
                    setColspan = 0;
                }

                //check if has merge colspan > 1
                if (colspan > 1) {
                    setColspan = Number(currentLoop) + Number(colspan);
                    return true;
                } else {
                    status = true;
                    if (setColspan != 0) {
                        //is merge column
                        return false;
                    } else {
                        //is not merge column
                        return true;
                    }
                }

            },
            setkey2(currentLoop, colspan) {
                if (checkM) {
                    // แสดงข้อมูล
                    if (colspan != 1) {  // แสดงข้อมูล merge
                        colspanM = colspan-1;
                        loopM = 0;
                        checkM = false;
                        return true;
                    } else { // แสดงข้อมูล default
                        return true;
                    }
                } else {
                    loopM++;
                    if (loopM == colspanM) {
                        checkM = true;
                    }
                    return false;
                }
            },
            setkey3(currentLoop, colspan) {
                if (checkM2) {
                    // แสดงข้อมูล
                    if (colspan != 1) {  // แสดงข้อมูล merge
                        colspanM2 = colspan-1;
                        loopM2 = 0;
                        checkM2 = false;
                        return true;
                    } else { // แสดงข้อมูล default
                        return true;
                    }
                } else {
                    loopM2++;
                    if (loopM2 == colspanM2) {
                        checkM2 = true;
                    }
                    return false;
                }
            },
            chkHeight(value) {
                let element = document.querySelector(value);
                // let hearder_height=document.querySelector('.header-wrapper');
                let get_height = element.getBoundingClientRect().height
            },
            setscroll() {
                this.$parent.scrollName('#show-table-maintenance')
                const self = this;

                // this.table_height=null
                // this.table_height2=null
                // this.table_height3=null
                window.animateDage()
                this.$nextTick(() => {
                    // will run after $emit is done

                    self.$parent.updateGuideline()
                    self.$parent.initPeriodicalTableScroll()


                })
            },
            setdataTable() {
                if (this.chkOpentableAll == false) {
                    this.chkOpentableAll = true;
                    this.setHeight();
                }
            },
            slidePrev() {
                $('.distance-table').removeClass('next').addClass('prev');
                $('.btn-prev').removeClass('show').addClass('hide');
                $('.btn-next').removeClass('hide').addClass('show');
            },
            slideNext() {
                $('.distance-table').removeClass('prev').addClass('next');
                $('.btn-prev').removeClass('hide').addClass('show');
                $('.btn-next').removeClass('show').addClass('hide');
            },
            scrollToShowTablePeriodical() {
                // $('html, body').animate({
                //     scrollTop: $('#show-table-maintenance').offset().top-80
                // }, 300);
                this.$parent.scrollName('#show-table-maintenance')
            },
            setHeightLoop(value) {
                // if(this.table_height!=null){
                //     return this.table_height[value]+17
                // }
                if (this.table_height3 != null) {
                    return this.table_height3[value] + 17
                }

            },
            setHeight() {
                var arr = [];
                var arr2 = [];
                var arr3 = [];

                if (this.dataTableservices != null) {
                    if (this.dataTableservices.dataall_show) {
                        this.dataTableservices.dataall_show.forEach((element, index) => {
                            arr.push(this.$refs['listCell' + index][0].clientHeight)
                            arr2.push(this.$refs['listCellSet' + index][0].clientHeight)
                        });
                        this.table_height = arr;
                        this.table_height2 = arr2;
                    }

                    for (i = 0; i < this.table_height.length; i++) {
                        if (Number(this.table_height[i]) > Number(this.table_height2[i])) {
                            arr3.push(this.table_height[i]);
                        } else {
                            arr3.push(this.table_height2[i]);
                        }
                    }
                    this.table_height3 = arr3;
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .collapsed>.when-open,
    .not-collapsed>.when-closed {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/service/ResultPeriodical.vue